
import GHGeometryObject from './GHGeometryObject';
import Events from '../Events';

export default class GHPaintListObject extends GHGeometryObject {
  constructor (ghObject, paints = []) {
    super(ghObject);

    this.paints = paints;
    this.keys = paints.map((v) => v.name);
    this.values = paints.map((v) => v.id);
    this.__selected = 0;
  }

  get selected () {
    return this.__selected;
  }

  set selected (v) {
    this.__selected = v;
  }

  change (v) {
    this.selected = v;
    this.emit(Events.UI_CHANGE, this);
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/GHPaintListObject.js